<template>
  <div v-if="appointmentTermsSigned.length || appointmentTerms.length">
    <v-divider class="my-8" />

    <h2 class="mb-8">
      {{ $t('appointment.label.terminationTerms') }}
    </h2>

    <AppointmentFilesTermList
      :terms="appointmentTerms"
      :signedTerms="appointmentTermsSigned"
      :showClickSignButton="showClickSignButton"
    />
  </div>
</template>

<script>
import AppointmentFilesTermList from './terms/AppointmentFilesTermList'

import { mapGetters } from 'vuex'

export default {
  name: 'AppointmentFilesTerm',

  props: {
    showClickSignButton: {
      type: Boolean,
      default: false,
    }
  },

  components: {
    AppointmentFilesTermList,
  },

  computed: {
    ...mapGetters(['appointmentTerms', 'appointmentTermsSigned']),
  },
}
</script>
